import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, X, Sparkles } from 'lucide-react';
export function TwoPaths() {
  return <section className="py-24 bg-white" data-id="element-220">
      <div className="max-w-5xl mx-auto px-6" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-900 mb-6" data-id="element-223">
            Llegaste a una encrucijada. <br className="hidden md:block" data-id="element-224" />
            <span className="italic text-[#C5A059] font-normal" data-id="element-225">
              Tienes dos caminos frente a ti...
            </span>
          </h2>
          <p className="text-stone-600 text-lg max-w-2xl mx-auto" data-id="element-226">
            La vida que deseas está a una sola decisión de distancia. ¿Qué vas a
            elegir hoy?
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-227">
          {/* Camino 1: Escasez */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-stone-50 rounded-3xl p-8 md:p-10 border border-stone-200 opacity-80 hover:opacity-100 transition-opacity" data-id="element-228">
            <div className="w-12 h-12 rounded-full bg-stone-200 flex items-center justify-center mb-6" data-id="element-229">
              <X className="w-6 h-6 text-stone-500" data-id="element-230" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-stone-800 mb-4" data-id="element-231">
              Camino 1: Seguir igual
            </h3>
            <p className="text-stone-600 leading-relaxed mb-6" data-id="element-232">
              Cierras esta página. Mañana te despiertas con la misma ansiedad
              financiera. Sigues persiguiendo el dinero, agotándote en el
              proceso, y permitiendo que el estrés dicte tus decisiones y afecte
              a tu familia.
            </p>
            <p className="text-stone-500 font-medium italic" data-id="element-233">
              El costo real de no hacer nada es seguir pagando con tu paz
              mental.
            </p>
          </motion.div>

          {/* Camino 2: Abundancia */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#FAF5E9] rounded-3xl p-8 md:p-10 border border-[#C5A059]/30 shadow-lg relative overflow-hidden" data-id="element-234">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#C5A059] opacity-10 rounded-bl-full" data-id="element-235"></div>
            <div className="w-12 h-12 rounded-full bg-[#C5A059]/20 flex items-center justify-center mb-6 relative z-10" data-id="element-236">
              <Sparkles className="w-6 h-6 text-[#A8823A]" data-id="element-237" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-stone-900 mb-4 relative z-10" data-id="element-238">
              Camino 2: El Código Invisible
            </h3>
            <p className="text-stone-700 leading-relaxed mb-6 relative z-10" data-id="element-239">
              Inviertes $6.39 USD hoy (menos de lo que cuesta un café). Lees el
              manual, aplicas el ritual y comienzas a sanar tu relación con la
              abundancia. Te conviertes en el jardín.
            </p>
            <p className="text-[#A8823A] font-bold italic relative z-10" data-id="element-240">
              Empiezas a recibir con gracia, paz y gratitud.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-241">
          <a href="https://pay.hotmart.com/L105538443T" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_30px_rgba(197,160,89,0.3)] transition-all hover:shadow-[0_0_50px_rgba(197,160,89,0.5)] hover:scale-105" data-id="element-242">
            <div className="absolute inset-0 gold-gradient" data-id="element-243"></div>
            <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-244"></div>
            <span className="relative flex items-center gap-2" data-id="element-245">
              ELIJO EL CAMINO DE LA ABUNDANCIA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-246" />
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}